function checkCartTotal() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      console.log("Carrito completo:", cart);
      const cartTotal = cart.total_price / 100;
      let adjustedCartTotal = cartTotal;
      let itemsToRemove = [];
      let upsellCount = 0;

      const productFetchPromises = cart.items.map(item => {
        const productUrl = `${window.Shopify.routes.root}products/${item.handle}.js`;

        return fetch(productUrl)
          .then(response => response.json())
          .then(product => {
            const variant = product.variants.find(v => v.id === item.variant_id);
            if (variant && variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price)) {
              adjustedCartTotal -= item.line_price / 100;
            }
          })
          .catch(error => {
            console.error("Error al obtener detalles del producto:", error);
          });
      });

      Promise.all(productFetchPromises).then(() => {
        cart.items.forEach(item => {
          if (item.properties && item.properties.Regalo === 'Yes') {
            upsellCount += item.quantity;
            const upsellValue = item.properties.upsell;
            if (adjustedCartTotal >= 100 && upsellValue === '70') {
              itemsToRemove.push(item.key);
            } else if (adjustedCartTotal < 100 && adjustedCartTotal >= 70 && upsellValue === '100') {
              itemsToRemove.push(item.key);
            } else if (adjustedCartTotal < 70) {
              itemsToRemove.push(item.key);
            }
          }
        });

        if ((adjustedCartTotal >= 100 && upsellCount >= 3) || 
            (adjustedCartTotal >= 70 && adjustedCartTotal < 100 && upsellCount >= 2)) {
          hideCarousels();
        } else {
          updateCarouselVisibility(adjustedCartTotal);
        }

        if (itemsToRemove.length > 0) {
          itemsToRemove.forEach(itemId => removeLineItem(itemId, adjustedCartTotal));
        }
      });
    });
}

function hideCarousels() {
  const upsellDiv = document.getElementById('carrousel-upsell');
  const carousel50 = document.getElementById('featured-collections-carousel-carrousel_over50');
  const carousel100 = document.getElementById('featured-collections-carousel-carrousel_over100');

  upsellDiv.style.display = 'none';
  carousel50.style.display = 'none';
  carousel100.style.display = 'none';
}

function removeLineItem(lineItemId, cartTotal) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: lineItemId,
      quantity: 0
    })
  })
  .then(() => {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  });
}

function updateCarouselVisibility(cartTotal) {
  const upsellDiv = document.getElementById('carrousel-upsell');
  const carousel50 = document.getElementById('featured-collections-carousel-carrousel_over50');
  const carousel100 = document.getElementById('featured-collections-carousel-carrousel_over100');

  if (cartTotal >= 70) {
    upsellDiv.style.display = 'block';
    if (cartTotal >= 100) {
      carousel50.style.display = 'none';
      carousel100.style.display = 'block';
    } else {
      carousel50.style.display = 'block';
      carousel100.style.display = 'none';
    }
  } else {
    upsellDiv.style.display = 'none';
  }
}

function refreshCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartTotal = cart.total_price / 100;
      updateCarouselVisibility(cartTotal);
      checkCartTotal();
    });
}

document.addEventListener('cart:refresh', refreshCart);
addEventListener("load", checkCartTotal);
document.addEventListener('cart:change', checkCartTotal);
document.addEventListener('cart:add', checkCartTotal);
